import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row row-add-url" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-5" }
const _hoisted_4 = { class: "col-1 col-md-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-delete" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import {useVuelidate} from '@vuelidate/core';
	import {url, requiredIf} from '@vuelidate/validators';
	import {computed, Ref, ref, onMounted} from 'vue';
	import FormInput from '@/components/forms/FormInput.vue';

	interface Props {
		initialLink: string;
		initialName: string;
		index: number;
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'FormCompanyRecordUrl',
  props: {
    initialLink: {},
    initialName: {},
    index: {}
  },
  setup(__props: any) {

const props = __props;

	

	const name: Ref = ref();
	const link: Ref = ref();

	const rules = computed(() => ({
		link: {
			requiredIfRef: requiredIf(name),
			url
		},
		name: {
			requiredIfRef: requiredIf(link)
		}
	}));
	const v$ = useVuelidate(rules, { link, name });

	onMounted(() => {
		name.value = props.initialName;
		link.value = props.initialLink;
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FormInput, {
        modelValue: _unref(v$).link.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).link.$model) = $event)),
        modelModifiers: { trim: true },
        validation: _unref(v$).link,
        "hide-label": "",
        "input-class": "input-fullwidth",
        label: "Link",
        required: "",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-link', { name: name.value, link: link.value })))
      }, null, 8, ["modelValue", "validation"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FormInput, {
        modelValue: _unref(v$).name.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).name.$model) = $event)),
        modelModifiers: { trim: true },
        validation: _unref(v$).name,
        "hide-label": "",
        "input-class": "input-fullwidth",
        label: "Naam",
        required: "",
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-link', { name: name.value, link: link.value })))
      }, null, 8, ["modelValue", "validation"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        "aria-label": "Verwijderen",
        class: "button button-no-border",
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('delete-link')))
      }, _hoisted_6)
    ])
  ]))
}
}

})